import { Controller } from 'stimulus'

// Bulk marking on the Sample Storage screen: ticking boxes shows the bar with
// the count, a date, and Mark Discarded / Mark Returned / Other…
export default class extends Controller {
  static targets = ['box', 'all', 'bar', 'count', 'other', 'note']

  connect() {
    this.update()
  }

  toggleAll() {
    const { checked } = this.allTarget
    this.boxTargets.filter(box => box.checked !== checked).forEach(box => box.click())
    this.update()
  }

  update() {
    const selected = this.boxTargets.filter(box => box.checked).length
    if (this.hasCountTarget) this.countTarget.textContent = selected
    if (this.hasBarTarget) {
      this.barTarget.classList.toggle('hidden', selected === 0)
      this.barTarget.classList.toggle('flex', selected > 0)
    }
    if (this.hasAllTarget) {
      this.allTarget.checked = selected > 0 && selected === this.boxTargets.length
    }
    this.boxTargets.forEach((box) => {
      const row = box.closest('tr')
      if (row) row.classList.toggle('is-selected', box.checked)
    })
  }

  showOther() {
    this.otherTarget.classList.remove('hidden')
    this.noteTarget.focus()
  }

  // "Mark Other" needs the note; the other two buttons don't.
  requireNote(event) {
    if (this.noteTarget.value.trim() === '') {
      event.preventDefault()
      this.noteTarget.required = true
      this.noteTarget.reportValidity()
    }
  }
}
